import { Button, Grid } from '@mairistem/composants';
import { formatMontant, type UserRole } from '@mairistem/finances-utils';
import React from 'react';
import type TypePeriode from '../../../../constants/simulation/typePeriode';
import type MontantSimulation from '../../../../interfaces/simulation/montantSimulation';
import isInputDisabled from '../../../../utils/simulation/input';

interface MontantsSimulationModalContentHeaderProps {
	loading: boolean;
	montantsSimulation: MontantSimulation[];
	onAddMontant: () => void;
	transfertCpta: boolean;
	typePeriode: TypePeriode;
	userRole: UserRole;
}

const MontantsSimulationModalContentHeader = ({
	loading,
	montantsSimulation,
	onAddMontant,
	transfertCpta,
	typePeriode,
	userRole,
}: MontantsSimulationModalContentHeaderProps) => (
	<>
		<Grid.Row>
			<Grid.Column width={2}>Total demandé</Grid.Column>
			<Grid.Column width={9}>
				{formatMontant(
					montantsSimulation.reduce(
						(totalDemande, montantSimulation) =>
							totalDemande + (montantSimulation.demande ?? 0),
						0,
					),
					2,
					false,
				)}
			</Grid.Column>
			<Grid.Column textAlign="right" width={5}>
				<Button
					basic
					content="Ajouter une demande"
					data-testid="addMontantButton"
					disabled={
						isInputDisabled(transfertCpta, typePeriode, userRole, true) ||
						loading
					}
					icon="plus"
					loading={loading}
					onClick={onAddMontant}
				/>
			</Grid.Column>
		</Grid.Row>
		{montantsSimulation.length > 0 && (
			<Grid.Row>
				<Grid.Column width={2}>Statut</Grid.Column>
				<Grid.Column width={2}>Demandé</Grid.Column>
				<Grid.Column width={2}>Proposé</Grid.Column>
				<Grid.Column width={2}>Voté</Grid.Column>
				<Grid.Column width={3}>Commentaire</Grid.Column>
				<Grid.Column width={2}>Origine</Grid.Column>
				<Grid.Column width={3}>Etiquettes</Grid.Column>
			</Grid.Row>
		)}
	</>
);

export default MontantsSimulationModalContentHeader;
